import { HttpErrorResponse } from '@angular/common/http';
import { Component } from '@angular/core';
import { LoginService } from 'services/api/auth/login.service';
import { LoginTypes } from '../../../models/client';
import { LoginByPinDto } from '../../../models/server/DataTransferObject/Objects/Permissions';
import { AuthenticationService } from '../../../services/api/auth/authentication.service';
import { ModalService } from '../../../services/ui/modal.service';
import { AppPermissions } from '../../../models/server/index-enums';
import { Observable } from 'rxjs';
import { PermissionService } from '../../../services/api/permission/permission.service';
import { GeneralSettingService } from '../../../services/api/setting/general-setting.service';
import { GeneralSettingDto } from '../../../models/server/index-objects';

@Component({
  selector: 'app-pin-login',
  templateUrl: './pin-login.page.html',
  styleUrls: ['./pin-login.page.scss'],
})
export class PinLoginPage {

  public pinChars: string[] = [];
  public pin: string = "";

  public displayBadgeLogin: boolean;

  constructor(
    private modalService: ModalService,
    private loginService: LoginService,
    private authService: AuthenticationService,
    private permissionService: PermissionService,
    private generalSettingService: GeneralSettingService
  ) {
    this.generalSettingService.cache().subscribe(x => this.updateSettings(x));
  }

  private updateSettings(settings: GeneralSettingDto): void {
    const setting = settings?.availableLoginMethod?.value ?? (LoginTypes.Pin | LoginTypes.Badge);
    this.displayBadgeLogin = this.permissionService.hasPermission(AppPermissions.UseBadgeLogin) && (setting & LoginTypes.Badge) == LoginTypes.Badge;
  }

  async addPin(char: number) {
    this.pinChars.push(char.toString());
    this.pin = this.pinChars.join('');
  }

  useBadgeLogin() {
    this.clear();
    this.modalService.dismissModal({
      changeLogin: LoginTypes.Badge
    });
  }

  clear() {
    this.pinChars = [];
    this.pin = this.pinChars.join('');
  }

  exit() {
    this.clear();
    this.modalService.dismissModal();
  }

  async done() {
    const loader = await this.modalService.createLoader();
    loader.present();

    try {
      const dto = new LoginByPinDto();
      dto.pin = this.pin;
      const locationIdentity = this.authService.getIdentity();
      const userResponse = await this.loginService.loginWithUserPin(locationIdentity, dto);

      this.modalService.dismissModal({
        token: userResponse.body
      });

    } catch (error) {
      if (error instanceof HttpErrorResponse && error.status == 404) {
        (await this.modalService.createConfirmationAlert('LOGIN.FAILEDHEADER', 'LOGIN.FAILEDMSG')).present();
      } else if (error instanceof HttpErrorResponse && error.status == 403) {
        (await this.modalService.createConfirmationAlert('LOGIN.FAILEDHEADER', 'LOGIN.FORBIDDENMSG')).present();
      } else {
        (await this.modalService.createErrorAlertWithDetail(error)).present();
      }
    }
    finally {
      loader.dismiss();
      this.clear();
    }
  }

  getColor() {
    if(this.pinChars.length < 1)
      return "secondary";

    return "success";
  }
}
